import { forConsole } from '../channels';
import type { ExtractValues } from '../helpers';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { SYSTEM_INPUT } from './topics';

export const SLEEP = 'SYSTEM/SLEEP' as const;

export const requestedBy = ['admin', 'user', 'system'] as const;
export type RequestedBy = ExtractValues<typeof requestedBy>;

export interface ISleepAction {
  type: typeof SLEEP;
  payload: {
    consoleId: string;
    timestamp: number;
    requestedBy: RequestedBy;
  };
}

export const sleepActionSchema = objectSchemaOf<ISleepAction>({
  type: Joi.string().valid(SLEEP).required(),
  payload: objectSchemaOf<ISleepAction['payload']>({
    consoleId: Joi.string().required(),
    timestamp: Joi.number().required(),
    requestedBy: Joi.string()
      .valid(...requestedBy)
      .required(),
  }),
});

export const sleep = actionCreator({
  type: SLEEP,
  topic: SYSTEM_INPUT,
  schema: sleepActionSchema,
  channels: [forConsole],
});
